import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import FormDrawerWrapper from '../../../../../../features/components/FormDrawerWrapper'
import ShortDigitalRightCreateForm from './ShortDigitalRightCreateForm'

import useManageDrawer from '../../../../../../hooks/formHooks/useManageDrawer'

import { getChoicesCountries } from '../../../../../../modules/actions/choices'
import { choicesCountriesWasLoadedSelector } from '../../../../../../modules/selectors/choices'

import { DIGITAL_RIGHT_CREATE } from '../../../../../../constants/forms'

const ShortDigitalRightCreate = ({ openBtnClassName }) => {
  const dispatch = useDispatch()

  const countriesWasLoaded = useSelector(choicesCountriesWasLoadedSelector)

  const { isFormOpen } = useManageDrawer({
    formName: DIGITAL_RIGHT_CREATE
  })

  useEffect(() => {
    if (isFormOpen && !countriesWasLoaded) {
      dispatch(getChoicesCountries())
    }
  }, [dispatch, isFormOpen, countriesWasLoaded])

  return (
    <FormDrawerWrapper
      formName={DIGITAL_RIGHT_CREATE}
      title="Create multi-platform campaign"
      openButtonText="Create multi-platform campaign"
      openBtnClassName={openBtnClassName}
      isFormLoading={!countriesWasLoaded}
    >
      <ShortDigitalRightCreateForm />
    </FormDrawerWrapper>
  )
}

export default ShortDigitalRightCreate
